export interface ProductRequest {
    lat: number,
    lng: number,
    radius: number,
    altitudeMin?: number,
    altitudeMax?: number,
    searchString?: string,
    perPage: number,
    year?: number[],
    media?: Media,
    page: number,
    sort: [SortField, SortDirection][]
    distance?: number,
    isHistoricImage?: boolean,
    isNighttime?: boolean,
    isPanoramic?: boolean,
    isSunrise?: boolean,
    isSunset?: boolean,
    isHighAltitude?: boolean,
}

export interface SortOption {
    id: SortField,
    name: string,
    sort: SortDirection
}

export enum ProdSpecific {
    SUNRISE = 'Sunrise',
    NIGHT_TIME = 'Night Time',
    HIGH_ALTITUDE = "High Altitude",
    PANORAMIC = 'Panoramic',
    ARCHIVE = 'Archive',
    SUNSET = 'Sunset',
}

export enum Filter {
    YEAR = 'Year',
    ALTITUDE = 'Altitude',
    MEDIA = 'Media',
    SPECIFIC = 'Category'
}

export enum Media {
    IMAGE = 'image',
    VIDEO = 'video',
    ALL = 'all'
}

export enum Altitude {
    M0 = '0-250m',
    M250 = '250-500m',
    M500 = '500-1000m',
    M1000 = '1000-2000m',
    M2000 = 'Over 2000m'
}

export enum SortField {
    ID = "id",
    NETO_ID = "netoId",
    NAME = "name",
    SKU = "sku",
    YEAR = "year",
    MEDIA = "media",
    IS_PREMIUM = "isPremium",
    DISTANCE = "distance",
    ALTITUDE = "altitude",
    CREATED_AT = "createdAt",
    UPDATED_AT = "updatedAt"
}

export enum SortDirection {
    ASC = 'asc',
    DESC = 'desc'
}

export enum CategoryRequestStatus {
    SUCCESS = 'Success'
}

export interface NetoCategory {
    ShortDescription1: string
}

export interface CategoryRequest {
    Ack: CategoryRequestStatus,
    Category: NetoCategory[]
}

export interface Category {
    name: string,
    add: string,
    total: string,
    remove: string,
    selected: string,
    value: string
    subItems?: Category[],
    searchPage: boolean
}

export enum GridClass {
    LIST = '',
    CARDS = 'cards'
}

export interface Product {
    id: number,
    netoId: number,
    name: string,
    sku: string,
    year: number,
    media: Media,
    thumbnailUrl: string,
    imageUrl: string,
    isPremium: true,
    lng: number,
    lat: number,
    altitude: number,
    geoLocation: string,
    createdAt: Date,
    updatedAt: Date,
    distance: string,
    productUrl: string,
    prevVideo: string,
    isHistoricImage: boolean,
    isNighttime: boolean,
    isPanoramic: boolean,
    isSunrise: boolean,
    isSunset: boolean,
    isHighAltitude: boolean,

}

export interface SearchMetadata {
    lat: number,
    lng: number,
    radius: number,
    year: number,
    page: number,
    perPage: number,
    isHistoricImage: boolean,
    isNighttime: boolean,
    isPanoramic: boolean,
    isSunrise: boolean,
    isSunset: boolean,
    itemsTotal: number,
    sort: [SortField, SortDirection]
}

export interface ProductResponse {
    searchMetadata: SearchMetadata,
    data: Product[]
}